import { appConstants } from "../constants/appConstants"

function updateToastTrue(text: any, type: any) {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.UPDATE_TOAST_TRUE,
      payload: { text, type },
    })
  }
}

function updateToastFalse() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.UPDATE_TOAST_FALSE,
    })
  }
}

function reset() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.RESET,
    })
  }
}

const toastAction = {
  updateToastTrue,
  updateToastFalse,
  reset
}

export default toastAction
